import { Box, BoxProps } from '@mui/material';
import { styled } from '@mui/system';

import { APP_LAYOUT_HEIGHT } from '@/config';
import { removeTheseProps } from '@/utils';

const CONTENT_MAX_HEIGHT =
  APP_LAYOUT_HEIGHT.HEADER + APP_LAYOUT_HEIGHT.CONTENT_HEADER;

type ContentLayoutOnlyProps = {
  fixedHeight?: boolean;
} & BoxProps;

export type ContentLayoutProps = ContentLayoutOnlyProps & BoxProps;

export const ContentLayout = styled(Box, {
  shouldForwardProp: removeTheseProps<ContentLayoutOnlyProps>('fixedHeight'),
})<ContentLayoutOnlyProps>(({ fixedHeight }) => ({
  maxHeight: fixedHeight ? `calc(100vh - ${CONTENT_MAX_HEIGHT}px)` : 'unset',
  overflow: fixedHeight ? 'auto' : 'unset',
}));

export const StyledContentLayout = styled(Box, {
  shouldForwardProp: removeTheseProps<ContentLayoutOnlyProps>('fixedHeight'),
})<ContentLayoutOnlyProps>(({ fixedHeight }) => ({
  maxHeight: fixedHeight ? `calc(100vh - ${CONTENT_MAX_HEIGHT}px)` : 'unset',
  padding: '26px 24px',
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
  overflow: fixedHeight ? 'auto' : 'unset',
}));
